<svg width="21" height="10" viewBox="0 0 21 10" fill="none" stroke="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M1.48438 5H19.4844M5.48438 9L1.48438 5L5.48438 9ZM1.48438 5L5.48438 1L1.48438 5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
